import { RoutePaths } from "../../routes";

const authLinks = [
  {
    href: RoutePaths.root,
    label: "Environments",
  },
  {
    href: RoutePaths.translationUpdater,
    label: "Update translations",
  },
  {
    href: RoutePaths.environmentsCompare,
    label: "Environments compare",
  },
  {
    href: RoutePaths.pullRequests,
    label: "Pull requests",
  },
  {
    href: RoutePaths.changelog,
    label: "Changelog",
  },
  {
    href: RoutePaths.hostedTools,
    label: "Hosted tools",
  },
];

const links = [
  {
    href: RoutePaths.root,
    label: "Environments",
  },
  {
    href: RoutePaths.login,
    label: "Login",
  },
];

export { authLinks, links };
